import { all, call, put, takeLatest } from "redux-saga/effects";
import { request } from "src/utils/api";
import { StatusCodes } from "http-status-codes";
import {
  fetchDriverListFailure,
  fetchDriverListSuccess,
} from "../slices/DriverSlice";
import { GET_DRIVER } from "../actions/DriverAction";
import notification from "antd/es/notification";

export function* fetchDriverSaga(action: any): Generator<any, void, any> {
  try {
    const result: any = yield call(request, action.payload);
    if (result.status == StatusCodes.OK)
      yield put(fetchDriverListSuccess(result));
    else {
      yield put(fetchDriverListFailure(result.message));
      notification.error({
        message: "Data Failed",
        description: result.message,
        placement: "topRight",
        showProgress: true,
      });
    }
  } catch (error: any) {
    yield put(fetchDriverListFailure(error.message));
  }
}

export default function* driverdetailsSaga() {
  yield all([takeLatest(GET_DRIVER, fetchDriverSaga)]);
}
